import CloseIcon from '@mui/icons-material/Close'
import {
  Box,
  Button,
  Card,
  CardMedia,
  Drawer,
  Grid,
  IconButton,
  Typography
} from '@mui/material'
import { memo, useMemo, useState } from 'react'
import Icon from '../../../../../../components/icon'
import { formatDateTime } from '../../../../../../utils/utils'

const AuxiliaryDeviceEvidenceDrawer = ({ evidences }) => {
  // State
  const [drawer, setDrawer] = useState(false)

  //Variable
  const sortedData = useMemo(() => {
    return evidences
      ?.map((item) => ({
        ...item,
        timestamp: item?.fileName?.split('.')?.[0]?.split('_')?.[1]
      }))
      .sort((a, b) => {
        return new Date(a?.timestamp) - new Date(b?.timestamp)
      })
  }, [evidences])

  // Helper function to format timestamp
  const formatTimestamp = (timestamp) => {
    const date = timestamp ? new Date(Number(timestamp)) : null

    return formatDateTime(date, false, false, true)
  }

  return (
    <>
      <Button
        variant="contained"
        className="editor-btn"
        onClick={() => setDrawer(true)}
        startIcon={
          <Icon
            icon="streamline:mobile-phone-camera-remix"
            style={{ fontSize: '14px' }}
          />
        }
        sx={{ padding: '5px 10px', fontSize: '12px' }}
      >
        Auxiliary Device Evidence
      </Button>

      {drawer && (
        <Drawer
          anchor="right"
          open={drawer}
          onClose={() => setDrawer(false)}
          PaperProps={{
            sx: {
              width: { xs: '100%', sm: '600px' },
              display: 'flex',
              flexDirection: 'column'
            }
          }}
          sx={{ zIndex: 99999 }}
        >
          {/* Fixed Header */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: 3,
              paddingBottom: 2,
              borderBottom: '1px solid',
              borderColor: 'divider',
              position: 'sticky',
              top: 0,
              backgroundColor: 'background.paper'
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              Auxiliary Device Evidence
            </Typography>
            <IconButton onClick={() => setDrawer(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              padding: 3,
              paddingTop: 2
            }}
          >
            {sortedData && sortedData.length > 0 ? (
              <Grid container spacing={2}>
                {sortedData.map((item, index) => (
                  <Grid item xs={12} key={index}>
                    <Card
                      sx={{
                        boxShadow: 2,
                        transition: 'transform 0.2s, box-shadow 0.2s',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                          boxShadow: 4
                        }
                      }}
                    >
                      <CardMedia
                        component="img"
                        image={item.url}
                        alt={item.fileName}
                        sx={{
                          width: '100%',
                          height: 'auto',
                          maxHeight: 400,
                          objectFit: 'contain',
                          cursor: 'pointer',
                          backgroundColor: '#f5f5f5'
                        }}
                        onClick={() => window.open(item.url, '_blank')}
                      />

                      <Box sx={{ padding: 1.5 }}>
                        {item?.timestamp && (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            fontWeight={500}
                          >
                            {formatTimestamp(item?.timestamp)}
                          </Typography>
                        )}
                      </Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '200px'
                }}
              >
                <Typography variant="body1" color="text.secondary">
                  No evidence images available
                </Typography>
              </Box>
            )}
          </Box>
        </Drawer>
      )}
    </>
  )
}

export default memo(AuxiliaryDeviceEvidenceDrawer)
